import { c as _c } from "react/compiler-runtime";
import { useWindow } from '@src/hooks/useWindow';
import { IS_SERVER_SIDE } from '@src/lib/server-side-rendering';
import Cookie from 'js-cookie';
import { useEffect } from 'react';
export const BreakpointCookieTracker = () => {
  const $ = _c(4);
  const window = useWindow();
  let t0;
  let t1;
  if ($[0] !== window) {
    t0 = () => {
      if (!IS_SERVER_SIDE) {
        const persistWidth = () => {
          Cookie.set("scoWindowWidth", String(window.innerWidth), {
            expires: 7
          });
        };
        persistWidth();
        window.addEventListener("resize", persistWidth);
        return () => window.removeEventListener("resize", persistWidth);
      }
    };
    t1 = [window];
    $[0] = window;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <></>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};